module.exports = __webpack_public_path__ + "img/윤영창.637e6ebe.jpg";